/**
 * The red asterisk of a required field (Standards §14.7), next to its label:
 *
 *     <Input label={<>{t('addPrinter.ipLabel')} <RequiredMark /></>} … />
 *
 * One component so the colour is the same everywhere; screen readers get the
 * field's own `required`/`aria-required`, not a «*» read aloud.
 */
import React from 'react';

export default function RequiredMark() {
    return (
        <span className="text-red-500 dark:text-red-400" aria-hidden="true">
            *
        </span>
    );
}
